import { colors } from '../../styles/colors';

export const onboardingStyles = {
    headerText: {
        fontSize: 25,
        color: colors.DARK_TEXT,
        marginTop: 50,
        textAlign: 'center',
    } as React.CSSProperties,
};



// WEBPACK FOOTER //
// ./src/Pages/OnboardingPages/OnboardingStyles.ts